export function filterEmptyKey (data) {
  const obj = {}
  Object.keys(data).forEach(item => {
    if (data[item] !== null && data[item] !== '' && typeof (data[item]) !== 'undefined' && !obj[item]) {
      obj[item] = data[item]
    }
  })
  return obj
}

export function getMenu (menus = [], url) {
  for (let i = 0; i < menus.length; i++) {
    if (url.includes(menus[i].url) && menus[i].url) {
      return menus[i]
    } else if (menus[i].childNode && menus[i].childNode.length) {
      const menu = getMenu(menus[i].childNode, url)
      if (menu) return menu
    }
  }
}

/**
 *var latlngs = [
 *    [40.41646957397461, 115.95511436462402],
 *    [40.411319732666016, 115.95399856567383],
 *    [40.40994644165039, 115.9647274017334],
 *    [40.416555404663086, 115.96558570861816]
 *  ]
 * 输入一组坐标计算中心点
 */
export function mapGetCenter (pointArray) {
  const sortedLongitudeArray = pointArray.map(item => item[1]).sort()
  const sortedLatitudeArray = pointArray.map(item => item[0]).sort()
  const centerLongitude = ((parseFloat(sortedLongitudeArray[0]) + parseFloat(sortedLongitudeArray[sortedLongitudeArray.length - 1])) / 2).toFixed(4)
  const centerLatitude = ((parseFloat(sortedLatitudeArray[0]) + parseFloat(sortedLatitudeArray[sortedLatitudeArray.length - 1])) / 2).toFixed(4)
  return [centerLongitude, centerLatitude]
}

/**
 * 将数字转成中文大写
 * @params num
 */
export function toChinesNum (num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    for (let i = 0; i < strArr.length; i++) {
      newNum = (i === 0 && strArr[i] === 0 ? '' : (i > 0 && strArr[i] === 0 && strArr[i - 1] === 0 ? '' : changeNum[strArr[i]] + (strArr[i] === 0 ? unit[0] : unit[i]))) + newNum
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) noWan = '0' + noWan
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

export function getIndexPath (list = []) {
  if (list[0].childNode && list[0].childNode.length) {
    return getIndexPath(list[0].childNode)
  } else {
    return list[0].url
  }
}

/**
 * px转vw，页面为vw布局，
 * @return px单位数值
*/
export function px2vw (px) {
  return Math.ceil(px * (document.documentElement.clientWidth / 1920))
}

/**
 * 深度克隆
 * @param {*} obj 需要深度克隆的对象
 * @returns {*} 克隆后的对象或者原值（不是对象）
 */
export function deepClone(obj, cache = new WeakMap()) {
  if (obj === null || typeof obj !== 'object') return obj
  if (cache.has(obj)) return cache.get(obj)
  let clone
  if (obj instanceof Date) {
    clone = new Date(obj.getTime())
  } else if (obj instanceof RegExp) {
    clone = new RegExp(obj)
  } else if (obj instanceof Map) {
    clone = new Map(Array.from(obj, ([key, value]) => [key, deepClone(value, cache)]))
  } else if (obj instanceof Set) {
    clone = new Set(Array.from(obj, value => deepClone(value, cache)))
  } else if (Array.isArray(obj)) {
    clone = obj.map(value => deepClone(value, cache))
  } else if (Object.prototype.toString.call(obj) === '[object Object]') {
    clone = Object.create(Object.getPrototypeOf(obj))
    cache.set(obj, clone)
    for (const [key, value] of Object.entries(obj)) {
      clone[key] = deepClone(value, cache)
    }
  } else {
    clone = Object.assign({}, obj)
  }
  cache.set(obj, clone)
  return clone
}

/**
 * JS对象深度合并
 * @param {object} target 需要拷贝的对象
 * @param {object} source 拷贝的来源对象
 * @returns {object|boolean} 深度合并后的对象或者false（入参有不是对象）
 */
export function deepMerge(targetOrigin = {}, source = {}) {
  const target = deepClone(targetOrigin)
  if (typeof target !== 'object' || typeof source !== 'object') return false
  for (const prop in source) {
    if (!Object.prototype.hasOwnProperty.call(source, prop)) continue
    if (prop in target) {
      if (source[prop] == null) {
        target[prop] = source[prop]
      } else if (typeof target[prop] !== 'object') {
        target[prop] = source[prop]
      } else if (typeof source[prop] !== 'object') {
        target[prop] = source[prop]
      } else if (target[prop].concat && source[prop].concat) {
        target[prop] = target[prop].concat(source[prop])
      } else {
        target[prop] = deepMerge(target[prop], source[prop])
      }
    } else {
      target[prop] = source[prop]
    }
  }
  return target
}
